import React, { useContext, useEffect, useState } from "react";
import { useMediaQuery } from "beautiful-react-hooks";

import Slide from "./slide";
import Slider from "./slider";
import { Dots } from "./dots";
import SliderContext from "./context";
// import data from "./data";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

import "./style.scss";
import { LanguageContext, text } from "../../container/language";
import Tags from "../Tags";
import { buildURLForArticle, buildURLForCategory } from "../../utils/buildURL";
import Link from "../../utils/Link";
import { useTranslation } from "react-i18next";
import Paragraph from "../Article/Paragraph";

export default function Presentation({ data }) {
  const { userLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();

  const leftPosition =
    "offset-lg-1 col-xl-6 col-xxl-5 text-center text-lg-start";
  const rightPosition =
    "offset-lg-5 col-xl-6 offset-xl-6 col-xxl-5 offset-xxl-6 text-center text-lg-start";

  return (
    <div className="hero-slider-wrapper bg-dark">
      <Carousel
        showStatus={false}
        showThumbs={false}
        autoPlay={true}
        infiniteLoop={true}
      >
        {data.map((item) => (
          <div
            className="owl-slide d-flex align-items-center bg-overlay bg-overlay-400"
            style={{
              backgroundImage: `url(https://admin.magjistratura.edu.al${item.image.url})`,
            }}
          >
            <div className="container">
              <div className="row">
                <div
                  className={`col-md-10 offset-md-1 col-lg-7 ${
                    item.textAlign === "RIGHT" ? rightPosition : leftPosition
                  } `}
                >
                  <h2
                    className="display-1 fs-56 mb-4 text-white animated-caption"
                    dataAnim="animate__slideInDown"
                    dataAnimDelay="500"
                  >
                    {text(item.title, userLanguage)}
                  </h2>
                  <p
                    className="lead fs-23 lh-sm mb-7 text-white animated-caption"
                    dataAnim="animate__slideInRight"
                    dataAnimDelay="1000"
                  >
                    <Paragraph data={item.description}></Paragraph>
                  </p>
                  <div
                    className="animated-caption"
                    dataAnim="animate__slideInUp"
                    dataAnimDelay="1500"
                  >
                    <Link
                      to={`${buildURLForArticle(item.article)}`}
                      className="btn btn-lg btn-outline-white rounded-pill"
                    >
                      {t("menu.seeAll")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}
